import axios from "axios";
import { supabase } from "../supabaseClient";

async function getAllTransactions(from, to, searchValue, sortBy, selectedDate) {
  // const limit = 10;
  // const fromCount = nextRange?.from;
  // const toCount = nextRange?.to;
  let query = supabase
    .rpc(
      "get_untaggedtransactions",
      { search_text: searchValue.replace(/,/g, "") },
      { count: "exact" }
    )
    .order("last_updated_at", {
      ascending: sortBy.includes("Oldest") ? true : false,
    })
    .range(from, to);

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("last_updated_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("last_updated_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }
  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}

async function refundFromTransactionPayment(body) {
  return new Promise((resolve, reject) => {
    // process.env.REACT_APP_PAYMENT_LINK_URL
    // 'http://192.168.2.113:8000/'
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL +
          "payments/refundUntaggedTransaction",
        body
      )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function autotagFromTransactionPayment(body) {
  return new Promise((resolve, reject) => {
    axios
      .post( process.env.REACT_APP_CLOSED_VIRTUAL_ACCOUNT_URL + "payments/tagUntaggedTransaction", body )
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export { getAllTransactions, refundFromTransactionPayment,autotagFromTransactionPayment };
